var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04351 6.96091C2.32554 6.96091 1.74351 7.54294 1.74351 8.26091V40.7827C1.74351 41.5006 2.32554 42.0827 3.04351 42.0827H42.8696C43.5876 42.0827 44.1696 41.5006 44.1696 40.7827V16.087C44.1696 15.369 43.5876 14.787 42.8696 14.787H24.2021L17.8083 7.4095C17.5614 7.12459 17.2029 6.96091 16.8259 6.96091H3.04351ZM0.343506 8.26091C0.343506 6.76975 1.55234 5.56091 3.04351 5.56091H16.8259C17.6089 5.56091 18.3534 5.90086 18.8663 6.4926L24.8414 13.387H42.8696C44.3608 13.387 45.5696 14.5958 45.5696 16.087V40.7827C45.5696 42.2738 44.3608 43.4827 42.8696 43.4827H3.04351C1.55234 43.4827 0.343506 42.2738 0.343506 40.7827V8.26091Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.bea8aabc.svg";
export { ForwardRef as ReactComponent };